
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".344","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M6.859 13.984c-.41 0-.616-.21-.616-.63V4.646c0-.42.21-.63.63-.63h5.082c.326 0 .49.158.49.476 0 .326-.164.49-.49.49H7.39v3.444h4.27c.336 0 .504.158.504.476 0 .326-.168.49-.504.49H7.39v3.962c0 .42-.178.63-.532.63z","fill":"#000"}})])
          )
        }
      }
    